import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import cx from 'classnames';
import React, { useState } from 'react';
import Downshift from 'downshift';
import matchSorter from 'match-sorter';
import FormFooter from './FormFooter';
import FormLabel from './FormLabel';
import { config } from '../helpers/config';

var ChoicesSingle = function ChoicesSingle(_ref) {
  var _cx;

  var className = _ref.className,
      disabled = _ref.disabled,
      explanationMessage = _ref.explanationMessage,
      label = _ref.label,
      options = _ref.options,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      name = _ref.name,
      required = _ref.required,
      removeItem = _ref.removeItem,
      validationMessage = _ref.validationMessage,
      searchPlaceholder = _ref.searchPlaceholder,
      selected = _ref.selected;

  var _useState = useState(''),
      value = _useState[0],
      setValue = _useState[1];

  var itemToString = function itemToString(item) {
    return item ? item.label : '';
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (selected.length && !value.length && e.keyCode === 8) {
      onChange(selected.slice(0, selected.length - 1));
    }
  };

  var handleInputChange = function handleInputChange(e) {
    setValue(e.target.value);
  };

  var handleChange = function handleChange(item) {
    onChange(name, item); // Clear out any typed values

    setValue('');
  };

  var optionsList = value.length ? matchSorter(options, value, {
    keys: ['label']
  }) : options;
  var formGroupClasses = cx('form-group', className, (_cx = {}, _cx[config.classes.notValid] = validationMessage, _cx[config.classes.required] = required, _cx));
  var selectedOption = selected !== -1 ? optionsList.find(function (x) {
    return x.value === selected;
  }) : -1;
  return React.createElement(Downshift, {
    inputValue: value,
    onChange: handleChange,
    selectedItem: selectedOption,
    itemToString: itemToString
  }, function (downshift) {
    var choicesClasses = cx('choices', {
      'is-focused is-open': downshift.isOpen
    });
    return React.createElement("div", {
      className: formGroupClasses
    }, React.createElement(FormLabel, downshift.getLabelProps(), label), React.createElement("div", {
      className: "form-choicesSelect",
      disabled: disabled
    }, React.createElement("div", {
      className: choicesClasses,
      "data-type": "select-one"
    }, React.createElement("div", {
      className: "choices__inner",
      onClick: downshift.openMenu
    }, React.createElement("div", {
      className: "choices__list choices__list--single"
    }, downshift.selectedItem && downshift.selectedItem !== -1 ? React.createElement("div", {
      className: "choices__item choices__item--selectable"
    }, downshift.selectedItem.label, removeItem && React.createElement("button", {
      type: "button",
      className: "choices__button",
      onClick: removeItem
    }, "Remove item")) : React.createElement("div", {
      className: "choices__item choices__item--selectable choices__placeholder"
    }, placeholder))), downshift.isOpen && React.createElement("div", {
      className: "choices__list choices__list--dropdown is-active"
    }, React.createElement("input", Object.assign({
      className: "choices__input",
      type: "text"
    }, downshift.getInputProps({
      placeholder: searchPlaceholder,
      onChange: handleInputChange,
      onKeyDown: handleKeyDown
    }))), React.createElement("div", Object.assign({
      className: "choices__list"
    }, downshift.getMenuProps()), optionsList.length > 0 ? optionsList.map(function (item, index) {
      // eslint-disable-next-line
      var itemClasses = cx('choices__item choices__item--choice', {
        'is-highlighted': downshift.highlightedIndex === index || downshift.selectedItem === item
      });
      return React.createElement("div", Object.assign({
        className: itemClasses
      }, downshift.getItemProps({
        item: item
      }), {
        key: item.value
      }), item.label);
    }) : React.createElement("div", {
      className: "choices__item choices__item--choice has-no-results"
    }, "No results found"))))), React.createElement(FormFooter, {
      explanationMessage: explanationMessage,
      validationMessage: validationMessage
    }));
  });
};

ChoicesSingle.defaultProps = {
  placeholder: 'Select',
  searchPlaceholder: 'Search',
  selected: -1
};
export default ChoicesSingle;